import React from "react";
import { Outlet, useLocation } from "react-router-dom";
import { motion } from "framer-motion";
import Navbar from "@/components/Navbar";
import Footer from "@/components/Footer";
import WhatsAppWidget from "@/components/WhatsAppWidget";
import { useSeo } from "@/seo/useSeo";

const pageVariants = {
  initial: { opacity: 0, y: 24 },
  enter: { opacity: 1, y: 0, transition: { duration: 0.6, ease: [0.22, 1, 0.36, 1] } },
  exit: { opacity: 0, y: -16, transition: { duration: 0.35, ease: [0.4, 0, 1, 1] } },
};

export default function Layout() {
  const location = useLocation();
  useSeo(location.pathname);
  return (
    <div className="page-root theme-light">
      <Navbar />
      <motion.main
        key={location.pathname}
        variants={pageVariants}
        initial="initial"
        animate="enter"
        exit="exit"
        className="pt-48 md:pt-56"
      >
        <Outlet />
      </motion.main>
      <Footer />
      <div className="tl-keep">
        <WhatsAppWidget />
      </div>
    </div>
  );
}
